const PREFIX = 'schedule-appointment-types';
export const AppointmentTypesV3TrackingIds = {
  createAppointmentTypeModalCreateBtn: 'create-appointment-type-modal-create-btn',
  createAppointmentTypeModalCancelBtn: 'create-appointment-type-modal-cancel-btn',
  editAppointmentTypeModalSaveBtn: 'edit-appointment-type-modal-save-btn',
  editAppointmentTypeModalCancelBtn: 'edit-appointment-type-modal-cancel-btn',
  newAppointmentTypeBtn: 'new-appointment-type-btn',
  bulkAssignmentModal: {
    applyAssignmentsBtn: `${PREFIX}:bulk-assignment-modal:apply-assignments-btn`,
    closeBtn: `${PREFIX}:bulk-assignment-modal:close-btn`,
    resetColorsBtn: `${PREFIX}:bulk-assignment-modal:reset-colors-btn`,
  },
  bulkAssignmentBanner: {
    assignColorsBtn: `${PREFIX}:bulk-assignment-banner:assign-colors-btn`,
  },
};
